import React from 'react';
import './PageTitle.scss';
import { getPlanSubscribe } from '../@helper/common/common';

const PageTitle = () => {

    const { title, form } = getPlanSubscribe();
    return (

        <div className="container container_center">
            <div className="title">
                <h1 className="title__heading-text">{title}</h1>
                <p className="title__text">{form}</p>
            </div>
        </div>
    );
};

export default PageTitle;